import type { PointOfUnity } from "./types";

// Content for the About page: DAWC's Points of Unity and its history.
// All rich text is Markdown.

export const aboutTitle = "ABOUT DAWC";

export const pointsOfUnityHeading = "Points of Unity";

/** Link out from the home page teaser to the full points on About. */
export const pointsOfUnityCtaLabel = "Read more";

export const pointsOfUnityIntro =
  "These are the principles we organize around:";

export const pointsOfUnity: PointOfUnity[] = [
  {
    id: "oppose-wars",
    heading:
      "We are a broad progressive anti-war organization that opposes all U.S. wars, interventions, and sanctions.",
    faqs: [
      {
        q: "What are interventions?",
        a: "Interventions are instances where the United States becomes involved in a foreign country or nation’s affairs, either through military or political means. Interventions can take the form of CIA coups, providing military training or equipment to foreign militias, or U.S. military operations, including bombings and ground invasions.",
      },
      {
        q: "What are sanctions?",
        a: "Sanctions are financial or trade restrictions imposed on countries or other entities which oppose U.S. foreign policy interests. Additionally, these restrictions often deter other countries from trading with the U.S.’s target country. Sanctions are extremely deadly, often causing heavy economic hardship to any target country and resulting in starvation, poverty, inability to access necessary healthcare, and other consequences.",
      },
    ],
  },
  {
    id: "oppose-mic",
    heading: "We oppose the U.S. Military Industrial Complex in all its forms.",
    faqs: [
      {
        q: "What is the U.S. Military Industrial Complex?",
        a: "The Military Industrial Complex refers to the relationship between the United States military and the “defense” industry and the war profiteers that supply it.",
      },
    ],
  },
  {
    id: "support-divest",
    // The campaign's three demands are spelled out in full on the Detroit
    // Divest page, so the point itself stays short.
    heading: "We support our Detroit Divest campaign.",
    faqs: [
      {
        q: "Why do you refer to Israel as “so-called israel”?",
        a: "We refuse to legitimize an apartheid state that is committing a genocide.",
      },
    ],
  },
];

export const historyHeading = "The History of DAWC";

// Markdown paragraphs. **bold** preserved from the original emphasis.
export const history: string[] = [
  "Detroit Anti-War Committee was founded in May 2024. Its founding members were participants in the Wayne State Encampment, which was set-up in response to the U.S.-backed genocide on Palestine and WSU administration’s continued refusal to divest from war profiteers. DAWC’s campaign for city-wide divestment emerged from the Encampment and the energy it provided to the pro-Palestine movement. Since then, **DAWC has flourished into a broad anti-war organization, fighting for Detroit to divest from war profiteers and genocidal israel.**",
  "In February 2025, Detroit Anti-War Committee participated in the founding conference of the Anti-War Action Network (AWAN). **AWAN is a national network of grassroots anti-war organizations** committed to building a broad movement **opposed to the greatest cause of injustice in the world today: the U.S. and its senseless, destructive wars, sanctions, and interventions.** Joining the Anti-War Action Network was a defining moment in DAWC’s history and the anti-war movement. DAWC’s participation in AWAN has given us access to resources from organizations across the country, allows us to participate in national calls to action, and provides us with opportunities to enrich our work like the People’s Summit for Korea. **Joining DAWC is more than just joining our campaign for divestment in Detroit — it is joining a national movement to oppose all U.S. aggression!**",
];
